import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API, fmtDate } from "./utils";
import { T } from "@/locales/tr";

export default function SnippetsTab({ pwd }) {
  const [snippets, setSnippets] = useState([]);
  const [editing, setEditing] = useState({ key: "", html: "", css: "", active: true });

  const load = async () => {
    try {
      const { data } = await axios.get(`${API}/admin/snippets`, { headers: { "X-Admin-Password": pwd } });
      setSnippets(data || []);
    } catch (e) { toast.error(T("Échec")); }
  };
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!editing.key.trim()) return toast.error(T("Clé requise"));
    try {
      await axios.post(`${API}/admin/snippets`, editing, { headers: { "X-Admin-Password": pwd } });
      toast.success(T("Snippet sauvegardé"));
      load();
      setEditing({ key: "", html: "", css: "", active: true });
    } catch { toast.error(T("Échec")); }
  };
  const del = async (key) => {
    if (!window.confirm(`Supprimer "${key}" ?`)) return;
    try {
      await axios.delete(`${API}/admin/snippets/${key}`, { headers: { "X-Admin-Password": pwd } });
      toast.success(T("Supprimé")); load();
    } catch { toast.error(T("Échec")); }
  };

  return (
    <div data-testid="admin-snippets-tab">
      <h2 className="font-display text-2xl text-[color:var(--papicoo-ink)] mb-4">{T("Snippets HTML/CSS · injection rapide")}</h2>
      <p className="text-sm text-[color:var(--papicoo-muted)] mb-5">
        {T("Crée des blocs HTML/CSS injectables sur le site via la clé. Récupérables côté front via")} <code>{T("GET /api/snippets")}</code>.
      </p>

      <div className="papicoo-card p-5 mb-5">
        <div className="text-[11px] uppercase tracking-[0.18em] text-[color:var(--papicoo-accent)] mb-3">{editing.id ? "Modifier" : T("Créer un nouveau snippet")}</div>
        <input
          data-testid="snippet-key"
          placeholder={T("Clé unique (ex: banner_promo, landing_header_extra)")}
          value={editing.key}
          onChange={(e) => setEditing({ ...editing, key: e.target.value.replace(/[^a-zA-Z0-9_-]/g, "_") })}
          className="w-full mb-2 px-3 py-2 rounded-lg border border-[color:var(--papicoo-border)] text-sm font-mono"
        />
        <textarea
          data-testid="snippet-html"
          placeholder={"\u003cdiv>Mon HTML\u003c/div>"}
          value={editing.html}
          onChange={(e) => setEditing({ ...editing, html: e.target.value })}
          rows={6}
          className="w-full mb-2 px-3 py-2 rounded-lg border border-[color:var(--papicoo-border)] text-xs font-mono"
        />
        <textarea
          data-testid="snippet-css"
          placeholder=".ma-classe { color: red; }"
          value={editing.css}
          onChange={(e) => setEditing({ ...editing, css: e.target.value })}
          rows={4}
          className="w-full mb-3 px-3 py-2 rounded-lg border border-[color:var(--papicoo-border)] text-xs font-mono"
        />
        <div className="flex justify-between items-center">
          <label className="text-xs inline-flex items-center gap-2">
            <input type="checkbox" checked={editing.active} onChange={(e) => setEditing({ ...editing, active: e.target.checked })} />
            {T("Actif")}
          </label>
          <button data-testid="snippet-save" onClick={save} className="px-4 py-2 rounded-full papicoo-btn-primary text-sm">{T("Enregistrer")}</button>
        </div>
      </div>

      <div className="papicoo-card p-0 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-[color:var(--papicoo-sand-deep)]/40 text-[color:var(--papicoo-muted)] text-[11px] uppercase tracking-[0.15em]">
            <tr><th className="text-left p-3">{T("Clé")}</th><th className="text-left p-3">{T("État")}</th><th className="text-left p-3">{T("MAJ")}</th><th className="text-left p-3">{T("Actions")}</th></tr>
          </thead>
          <tbody>
            {snippets.length === 0 ? (
              <tr><td colSpan={4} className="text-center italic text-[color:var(--papicoo-muted)] py-8">{T("Aucun snippet.")}</td></tr>
            ) : snippets.map((s) => (
              <tr key={s.key} className="border-t border-[color:var(--papicoo-border)]">
                <td className="p-3 font-mono text-xs">{s.key}</td>
                <td className="p-3 text-xs">{s.active ? "✅ Actif" : "💤 Inactif"}</td>
                <td className="p-3 text-[11px] text-[color:var(--papicoo-muted)]">{fmtDate(s.updated_at)}</td>
                <td className="p-3 flex gap-2">
                  <button onClick={() => setEditing(s)} className="text-xs underline">{T("Éditer")}</button>
                  <button onClick={() => del(s.key)} className="text-xs text-red-600 underline">{T("Supprimer")}</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
